import styled from 'styled-components';
import { Content } from '../../../theme/layout';
import { themeColor } from '../../../theme/getters';
import { media } from '../../../theme/media';
import { Icon } from '../icon/icon.component';
import { nonResponsiveSmallSpacedHeading, paragraph } from '../../../theme/typography';
import { TargetLink } from '../targetLink';

export const BackgroundWrapper = styled.div`
  width: 100%;
  background-color: ${themeColor('primary')};
  padding-top: 56px;
  padding-bottom: 64px;
  color: ${themeColor('white')};

  ${media.tablet`
    padding-top: 80px;
    padding-bottom: 56px;
  `};
`;

export const Container = styled(Content)``;

export const Logo = styled(Icon).attrs(() => ({ size: 76 }))`
  color: ${themeColor('white')};
  float: right;
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  ${media.tablet`
    flex-direction: row;
  `};
`;

export const AppStoreLink = styled(TargetLink)`
  display: inline-block;
  font-size: 0;
  line-height: 0;
`;
export const AppStoreIcon = styled.img``;
export const Disclaimer = styled.p`
  ${paragraph};
  color: ${themeColor('white')};
  margin-top: 32px;
  margin-bottom: 56px;
  ${media.tablet`
    margin: 0;
    flex-grow: 1;
    padding-left: 32px;
  `};
`;
export const Copyright = styled.p`
  ${nonResponsiveSmallSpacedHeading};
  color: ${themeColor('border')};
  text-transform: none;
`;
export const SubFooter = styled.section`
  text-align: left;
  ${media.tablet`
    display: flex;
    margin-top: 190px;
    align-items: center;
    justify-content: space-between;
  `};
`;
